<template>
  <v-sheet class="wall-with-floor-background" height="100%">
    <v-row class="fill-height" align="center" justify="center">
      <v-col
        align="center"
        justify="center"
        :cols="columns"
        style="max-height: 85vh; overflow-y: auto;"
      >
        <v-img src="../../public/static/Easel Top.png" :width="easelTop" />
        <div @click="toggleDialog" style="cursor:pointer">
          <v-img
            src="https://streetcar-east.s3.us-east-2.amazonaws.com/proposedTypicalCrossSections.png"
            style="max-width: 95%;"
          />
        </div>
        <v-img
          src="../../public/static/Easel Bottom.png"
          :width="easelBottom"
        />
      </v-col>
      <v-col :cols="columns">
        <v-card class="slide-card" style="max-width: 90%;">
          <div class="slide-content">
            <h1 id="header">Proposed Typical Cross Sections</h1>
            <p>
              The following display provides renderings of three typical cross
              sections along the Streetcar East Extension project route. There
              are two alternatives for space allocation being considered along
              Edgewood Avenue.
            </p>
            <br />
            <h3>
              Click the proposed typical cross section display to view the
              options in greater detail.
            </h3>
          </div>
        </v-card>
      </v-col>
    </v-row>
    <ImagePopup v-if="toggled" :close-modal="toggleDialog" :image="image" />
  </v-sheet>
</template>

<script>
import ImagePopup from "@/components/ImagePopup.vue";

export default {
  name: "CrossSections",
  components: {
    ImagePopup
  },
  data() {
    return {
      toggled: false,
      image:
        "https://streetcar-east.s3.us-east-2.amazonaws.com/proposedTypicalCrossSections.png"
    };
  },
  computed: {
    easelTop() {
      if (this.$vuetify.breakpoint.xs) {
        return "25%";
      }
      return "10%";
    },
    easelBottom() {
      if (this.$vuetify.breakpoint.xs) {
        return "80%";
      }
      return "50%";
    },
    columns() {
      if (this.$vuetify.breakpoint.xs) {
        return 12;
      }
      return 6;
    }
  },
  methods: {
    toggleDialog() {
      this.toggled = !this.toggled;
    }
  }
};
</script>
